import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { isEmpty, size } from "lodash";
import playlistStore from "../../zustand/playlist.store";
import musicPlayerStore from "../../zustand/musicPlayer.store";
import likedSongsStore from "../../zustand/likedSong.store";
import userStore from "../../zustand/user.store";
import { getSongs } from "../../pages/editPlaylistPage/editPlayListPage.helpers";
import { getFormattedSongs } from "../../zustand/general.helper";
import { addSongToFavorites, removeSongFromFavorites } from "../../actions/songs.actions";
import { getRandomColor } from "../../helpers/generel.helpers";
import { showToaster } from "../../helpers/toaster.helpers";
import ThumbNail from "../../components/thumbNail/ThumbNail";
import { MEDIA_URL } from "../../axios";
import MobileHeader from "../components/MobileHeader";
import MobileSongList from "../components/MobileSongList";
import styles from "./MobileEditPlaylist.module.scss";

const MobileEditPlaylist = () => {
  const params = useParams();
  const navigate = useNavigate();
  const isNewPlaylist = !params.id;

  const { playlists } = playlistStore();
  const { setSongs: setPlayerSongs, setPlayList, setIsPlaying, setCurrentSongIndex } = musicPlayerStore();
  const { addSong: addLikedSong, deleteSong: deleteLikedSong } = likedSongsStore();
  const { userOffline } = userStore((state) => ({ userOffline: state.userOffline }));

  const [currentPlaylist, setCurrentPlaylist] = useState(null);
  const [playlistName, setPlaylistName] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const isSomethingChanged = useRef(false);

  useEffect(() => {
    if (isNewPlaylist) {
      setCurrentPlaylist({ songs: [], name: "New Playlist", isNewPlayList: true, color: getRandomColor() });
      setPlaylistName("New Playlist");
    } else {
      const pl = getSongs({ id: params.id }, playlists);
      setCurrentPlaylist(pl);
      setPlaylistName(pl?.name || "");
    }
  }, [params.id, playlists, isNewPlaylist]);

  const handlePlay = () => {
    if (!currentPlaylist?.songs?.length) return;
    const formatted = getFormattedSongs(currentPlaylist.songs);
    let songsToSet = formatted;
    if (window.__4playEngine) {
      window.__4playEngine.primeElements();
      const result = window.__4playEngine.switchPlaylist(formatted, 0);
      if (result) songsToSet = result;
    }
    setPlayerSongs(songsToSet, 0);
    setPlayList(currentPlaylist);
    setCurrentSongIndex(0);
    setIsPlaying(true);
    navigate("/mobile");
  };

  const handleSongClick = (index) => {
    if (!currentPlaylist?.songs?.length) return;
    const formatted = getFormattedSongs(currentPlaylist.songs);
    let songsToSet = formatted;
    if (window.__4playEngine) {
      window.__4playEngine.primeElements();
      const result = window.__4playEngine.switchPlaylist(formatted, index);
      if (result) songsToSet = result;
    }
    setPlayerSongs(songsToSet, index);
    setPlayList(currentPlaylist);
    setCurrentSongIndex(index);
    setIsPlaying(true);
  };

  const handleLikeClick = async (song, isAlreadyLiked) => {
    if (userOffline) return showToaster("error", "You are offline");
    const { id, index = "1.0" } = song;
    if (isAlreadyLiked) deleteLikedSong(id); else addLikedSong(id);
    const ok = isAlreadyLiked
      ? await removeSongFromFavorites({ song_id: id })
      : await addSongToFavorites({ song_id: id, index });
    if (!ok) { if (isAlreadyLiked) addLikedSong(id); else deleteLikedSong(id); }
  };

  if (!currentPlaylist) {
    return <div className={styles.page}><div className={styles.loader}>Loading...</div></div>;
  }

  return (
    <div className={styles.page}>
      <MobileHeader title={isNewPlaylist ? "New Playlist" : "Edit Playlist"} showBack />
      <div className={styles.hero}>
        <div className={styles.heroArt}>
          <ThumbNail
            name={currentPlaylist.name}
            color={currentPlaylist.color}
            hasImage={!!currentPlaylist.image}
            imgSrc={`${MEDIA_URL}/playlist_images/${currentPlaylist.image}`}
            imageFileName={currentPlaylist.image}
          />
        </div>
        <div className={styles.heroInfo}>
          {isEditing ? (
            <input
              className={styles.nameInput}
              value={playlistName}
              onChange={(e) => { setPlaylistName(e.target.value); isSomethingChanged.current = true; }}
              onBlur={() => setIsEditing(false)}
              autoFocus
            />
          ) : (
            <p className={styles.heroTitle} onClick={() => setIsEditing(true)}>{playlistName}</p>
          )}
          <p className={styles.heroCount}>{size(currentPlaylist.songs)} songs</p>
          <div className={styles.heroActions}>
            <button className={styles.playAllBtn} onClick={handlePlay}>Play All</button>
          </div>
        </div>
      </div>
      {!isEmpty(currentPlaylist.songs) && (
        <MobileSongList
          songs={getFormattedSongs(currentPlaylist.songs)}
          onSongClick={handleSongClick}
          onLikeClick={handleLikeClick}
        />
      )}
    </div>
  );
};

export default MobileEditPlaylist;
